import { render } from "./enterpriseLimiting.vue?vue&type=template&id=37754324&scoped=true"
import script from "./enterpriseLimiting.vue?vue&type=script&lang=js"
export * from "./enterpriseLimiting.vue?vue&type=script&lang=js"

import "./enterpriseLimiting.vue?vue&type=style&index=0&id=37754324&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-37754324"

export default script